import {handleEmailSending} from "../../helpers/email/emailHelper.ts";
import {fromCharCode} from "@opay/lib-core-js";

const OpayInfoContactEmail = () => {

    const name = fromCharCode(105, 110, 102, 111);
    const domain = fromCharCode(111, 112, 97, 121, 46, 101, 117);

    return (
        <>
            <a className="contact-by-email" href='#' onClick={(e) => handleEmailSending(e, name, domain)}>
                {`${fromCharCode(105, 110, 102, 111, 64, 111, 112, 97, 121, 46, 101, 117)}`}
            </a>
        </>
    )
}

export default OpayInfoContactEmail;
